import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { areaManagersQueryOptions } from '@/features/users/api/users.api';
import { useOrgGeoFilterOptions } from '@/hooks/useOrgGeoFilterOptions';
import { getFilterPanelProps } from '@/hooks/useUrlSyncedFilters';
import { appVersionListQueryOptions } from '../api/appVersionCheck.api';
import type { useAppVersionCheckFilters } from '../hooks/useAppVersionCheckFilters';
import { getAppVersionCheckFilterFields } from '../utils/getAppVersionCheckFilterFields';

interface AppVersionCheckFilterPanelProps {
  controller: ReturnType<typeof useAppVersionCheckFilters>;
}

export function AppVersionCheckFilterPanel({ controller }: AppVersionCheckFilterPanelProps) {
  const { filterValues } = controller;

  const { data: versions } = useQuery(appVersionListQueryOptions());
  const { data: reportingMembers } = useQuery(areaManagersQueryOptions());
  const orgGeoOptions = useOrgGeoFilterOptions(filterValues);

  return (
    <AdvancedFilterPanel
      fields={getAppVersionCheckFilterFields(filterValues, {
        versions,
        reportingMembers,
        ...orgGeoOptions,
      })}
      {...getFilterPanelProps(controller)}
    />
  );
}
